import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { convertToUserDateFormate } from 'utils/helpers'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function ListOperations({ fetchOperations, operations, setSelectedRows }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const siteUser = useSelector((store) => store.user)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])

  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  // LAP-733 (GE022)
  const columns = useMemo(
    () => [
      // { field: 'id', headerName: 'ID', width: 90 },
      {
        field: 'Type',
        headerName: t('vehicles.headerType'),
        width: 140,
        valueGetter: (params) => `${params.row.vehicletypes.vehicletype}`,
      },
      {
        field: 'Name',
        headerName: t('vehicles.headerName'),
        width: 200,
        editable: true,
        renderCell: (params) => `${params.row.Nom || params.row.Name}`,
      },
      {
        field: 'Marque',
        headerName: t('vehicles.headerBrand'),
        width: 110,
        editable: true,
        valueGetter: (params) => `${params.row.Marques.Marque}`,
      },
      {
        field: 'Statut',
        headerName: t('vehicles.headerStatus'),
        width: 110,
        editable: true,
        // valueGetter: (params) => `${params.row.Marques.Marque}`,
      },
      {
        field: 'Model',
        headerName: t('vehicles.headerModel'),
        width: 100,
        editable: true,
        valueGetter: (params) => `${params.row.Models.Name}`,
      },
      {
        field: 'Vhpower',
        headerName: t('vehicles.headerEnergy'),
        width: 80,
        editable: true,
      },
      {
        field: 'KLMT',
        headerName: t('vehicles.headerMileage'),
        width: 100,
        editable: true,
      },
      {
        field: 'Conso',
        headerName: t('vehicles.headerAvgConsumption'),
        width: 130,
        editable: true,
      },
      {
        field: 'Contact',
        headerName: t('vehicles.headerMainDriver'),
        width: 180,
        editable: true,
      },
      {
        field: 'DatePurch',
        headerName: t('vehicles.headerAcquisitionDate'),
        width: 140,
        editable: false,
        valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.DatePurch),
      },
      {
        field: 'DateSale',
        headerName: t('vehicles.headerSaleDate'),
        width: 110,
        editable: false,
        valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.DateSale),
      },
      {
        field: 'Vhvalue',
        headerName: t('vehicles.headerMarketValue'),
        width: 120,
        editable: true,
      },
    ],
    [t, siteUser.user],
  )

  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          field: 'Nom',
          headerName: t('vehicles.headerName'),
          width: 290,
          renderCell: (params) => (
            <Box py={2} mt={1}>
              <Box fontWeight={600}>{params.row.Nom || params.row.Name}</Box>
              <Box>
                {/* LAP-733 (GE022) */}
                <Box component={'span'}>{t('vehicles.headerBrand')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.Marques.Marque}
                </Box>
              </Box>
              <Box>
                {/* LAP-733 (GE022) */}
                <Box component={'span'}>{t('vehicles.headerModel')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.Models.Name}
                </Box>
              </Box>
              <Box>
                {/* LAP-733 (GE022) */}
                <Box component={'span'}>{t('vehicles.headerAcquisitionDate')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {convertToUserDateFormate(siteUser.user, params.row.DatePurch)}
                </Box>
              </Box>
              <Box>
                {/* LAP-733 (GE022) */}
                <Box component={'span'}>{t('vehicles.headerType')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.vehicletypes.vehicletype}
                </Box>
              </Box>
            </Box>
          ),
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile, columns, t, siteUser.user])
  return (
    <div
      style={{
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {/* LAP-733 (GE022) */}
        {t('vehicles.pageTitle')} ({operations.count})
      </Typography>

      <DataGrid
        sx={{ height: 750 }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        pageSize={rows}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        // disableSelectionOnClick
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(e) => navigate(`/domicile/vehicule/${e.row.id}`)}

        // onRowClick={(params, event) => {
        //   if (event.target.localName === 'div') {
        //     // window.open(params.row.Lien)
        //     navigate(`/domicile/vehicule/{}`)
        //   }
        // }}
      />
    </div>
  )
}
export default ListOperations
